import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { ProfileComponent } from '../profile/profile.component';
import { NewsComponent } from './splasboard/news/news.component';
import { LogbooksSectionComponent } from './splasboard/logbooks-section/logbooks-section.component';
import { AnnualProgramComponent } from './annual-program/annual-program.component';
import { ImplementationSassisopaComponent } from '../implementation-sassisopa/implementation-sassisopa.component';
import { CovidComponent } from './splasboard/covid/covid.component';
import { NomBullyingComponent } from './splasboard/nom-bullying/nom-bullying.component';
import { CalendarComponent } from './calendar/calendar.component';
import { LegalRequirementsComponent } from './splasboard/legal-requirements/legal-requirements.component';
import { SassisopaComponent } from './splasboard/sassisopa/sassisopa.component';
import { SgmComponent } from './splasboard/sgm/sgm.component';
import { EmployeesComponent } from '../employees/employees.component';
import { SysUsersComponent } from '../sys-users/sys-users.component';
import { TutorialsComponent } from './splasboard/tutorials/tutorials/tutorials.component';
import { SplasboardComponent } from './splasboard/splasboard.component';
import { AccountGuard } from '../account.guard';
import { SignatureGuard } from '../signature.guard';
import {NotificationsComponent} from './splasboard/notifications/notifications.component';
import {ServicesComponent} from './splasboard/services/services.component';
import { DocumentsComponent } from '../implementation-sassisopa/documents/documents.component';
import { DetailComponent } from '../implementation-sassisopa/documents/detail/detail.component';
import {StatisticsComponent} from './splasboard/statistics/statistics.component'
import { FormatManagerComponent } from '../implementation-sassisopa/format-manager/format-manager.component';

const routes: Routes = [{
  path: '',
  component: PagesComponent,
  children: [
    {
      path: 'cuenta',
      component: SplasboardComponent,
      canActivate: [AccountGuard],
    },
    {
      path: 'notificaciones',
      component: NotificationsComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'noticias',
      component: NewsComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'servicios',
      component: ServicesComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'indicadores/:stationId',
      component: StatisticsComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'bitacoras/:stationId',
      component: LogbooksSectionComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'programa-anual/:stationId',
      component: AnnualProgramComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'implementacion-sasisopa/:stationId',
      component: ImplementationSassisopaComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'covid-19/:stationId',
      component: CovidComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'nom-035/:stationId',
      component: NomBullyingComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'calendario/:stationId',
      component: CalendarComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'requisitos-legales/:stationId',
      component: LegalRequirementsComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'sasisopa/:stationId',
      component: SassisopaComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'sgm-test/:stationId',
      component: SgmComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'personal/:stationId',
      component: EmployeesComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'usuarios/:stationId',
      component: SysUsersComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'tutoriales/:stationId',
      component: TutorialsComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: 'profile',
      component: ProfileComponent,
      canActivate: [SignatureGuard],
    },
    {
      path: '',
      redirectTo: 'noticias',
      pathMatch: 'full',
    },
    /*
    {
      path: '**',
      component: NotFoundComponent,
    },
     */
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
